export default {"src":"/_next/static/media/evaluation_framework.b76c03b1.svg","height":50,"width":51,"blurWidth":0,"blurHeight":0};